var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankCard1Back(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 240.95 155.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2a374b;font-size:11px;}.cls-1,.cls-2{font-family:CFArmadilloStd-Medium, 'CF Armadillo Std';font-weight:500;}.cls-3,.cls-2{fill:#fff;}.cls-4{letter-spacing:.01em;}.cls-5{letter-spacing:0em;}.cls-2{font-size:9px;}.cls-6{opacity:.6;}.cls-7{clip-path:url(#clippath-2);}.cls-8{fill:#373535;}.cls-9{stroke:#42b654;}.cls-9,.cls-10{stroke-miterlimit:10;}.cls-9,.cls-10,.cls-11{fill:none;}.cls-12{letter-spacing:0em;}.cls-13{clip-path:url(#clippath-1);}.cls-14{clip-path:url(#clippath-4);}.cls-10{stroke:#90d0b9;}.cls-15{fill:#73c16e;}.cls-16{clip-path:url(#clippath);}.cls-17{clip-path:url(#clippath-3);}.cls-18{letter-spacing:0em;}.cls-19{clip-path:url(#clippath-5);}.cls-20{letter-spacing:0em;}.cls-21{letter-spacing:0em;}.cls-22{letter-spacing:0em;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    width: 240.95,
    height: 155.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    width: 240.95,
    height: 155.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    width: 240.95,
    height: 155.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    width: 240.95,
    height: 155.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    width: 240.95,
    height: 155.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 184.99,
    y: 33,
    width: 39.7,
    height: 22.68
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artwork_2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m224.44,155.91H16.5C7.39,155.91,0,148.52,0,139.41V16.5C0,7.39,7.39,0,16.5,0h207.95c9.11,0,16.5,7.39,16.5,16.5v122.91c0,9.11-7.39,16.5-16.5,16.5"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(14.63 115.47)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 0,
    y: 0
  }, "ww"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 14.32,
    y: 0
  }, "w.cap"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 41.11,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 45.04,
    y: 0
  }, "o.com /card"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 101.63,
    y: 0
  }, "s")), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m224.13,155.91H16.82c-9.29,0-16.82-7.53-16.82-16.82v-21.94h240.95v21.94c0,9.29-7.53,16.82-16.82,16.82"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 16.25,
    y: 33,
    width: 121.89,
    height: 22.68
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(17.45 27.73)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 0,
    y: 0
  }, "Exp. "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 19.31,
    y: 0
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 25.09,
    y: 0
  }, "ate: 05/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 57.2,
    y: 0
  }, "2"), /*#__PURE__*/React.createElement("tspan", {
    x: 62.71,
    y: 0
  }, "9")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(101.93 27.73)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 0,
    y: 0
  }, "CV"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 10.07,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 15.23,
    y: 0
  }, ":"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 17.39,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 19.99,
    y: 0
  }, "99"), /*#__PURE__*/React.createElement("tspan", {
    x: 30.75,
    y: 0
  }, "8")), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m219.46,55.68h-29.25c-2.89,0-5.22-2.34-5.22-5.22v-12.23c0-2.89,2.34-5.22,5.22-5.22h29.25c2.89,0,5.22,2.34,5.22,5.22v12.23c0,2.89-2.34,5.22-5.22,5.22"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m8.93,71.16c0-1.14.35-2.13,1.05-2.95.92-1.09,2.32-1.66,3.75-1.66h27.76c1.26,0,2.34.44,3.25,1.32.9.88,1.36,1.98,1.36,3.28v21.71c0,1.31-.45,2.4-1.36,3.28-.91.88-1.99,1.33-3.25,1.33H13.72c-1.43,0-2.83-.57-3.75-1.66-.7-.82-1.04-1.8-1.04-2.95v-21.71Zm32.75,22.09v-22.48c0-.06-.05-.12-.12-.12H14.45c-.61,0-1.11.5-1.11,1.11v20.5c0,.61.5,1.11,1.11,1.11h27.11c.06,0,.12-.05.12-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m32.21,78.67c0-.4.14-.74.42-1.01.28-.27.61-.41,1-.41h8.62c.39,0,.72.14,1,.41.28.27.42.61.42,1.01v6.69c0,.4-.14.74-.42,1.01-.28.27-.61.41-1,.41h-8.62c-.39,0-.72-.14-1-.41-.28-.27-.42-.61-.42-1.01v-6.69Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 21.34,
    cy: 82.02,
    r: 5.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m83.74,92.87c0,1.15-.35,2.13-1.04,2.95-.92,1.09-2.32,1.66-3.75,1.66h-27.76c-1.26,0-2.35-.44-3.25-1.32-.9-.88-1.36-1.98-1.36-3.28v-21.71c0-1.3.45-2.4,1.36-3.28.9-.88,1.99-1.32,3.25-1.32h27.76c1.43,0,2.83.57,3.75,1.66.7.82,1.04,1.8,1.04,2.95v21.71Zm-32.63.5h27.11c.61,0,1.11-.5,1.11-1.11v-20.5c0-.61-.5-1.11-1.11-1.11h-27.11c-.06,0-.12.05-.12.12v22.48c0,.06.05.12.12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m60.46,85.36c0,.4-.14.74-.42,1.01-.28.27-.61.41-1,.41h-8.62c-.39,0-.72-.14-1-.41-.28-.27-.42-.61-.42-1.01v-6.69c0-.4.14-.74.42-1.01.28-.27.61-.41,1-.41h8.62c.39,0,.72.14,1,.41.28.27.42.61.42,1.01v6.69Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 71.32,
    cy: 82.02,
    r: 5.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m233.84,92.87c0,1.15-.35,2.13-1.04,2.95-.92,1.09-2.32,1.66-3.75,1.66h-27.76c-1.26,0-2.35-.44-3.25-1.32-.9-.88-1.36-1.98-1.36-3.28v-21.71c0-1.3.45-2.4,1.36-3.28.9-.88,1.99-1.32,3.25-1.32h27.76c1.43,0,2.83.57,3.75,1.66.7.82,1.04,1.8,1.04,2.95v21.71Zm-32.63.5h27.11c.61,0,1.11-.5,1.11-1.11v-20.5c0-.61-.5-1.11-1.11-1.11h-27.11c-.06,0-.12.05-.12.12v22.48c0,.06.05.12.12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m210.57,85.36c0,.4-.14.74-.42,1.01-.28.27-.61.41-1,.41h-8.62c-.39,0-.72-.14-1-.41-.28-.27-.42-.61-.42-1.01v-6.69c0-.4.14-.74.42-1.01.28-.27.61-.41,1-.41h8.62c.39,0,.72.14,1,.41.28.27.42.61.42,1.01v6.69Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 221.43,
    cy: 82.02,
    r: 5.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m84.22,71.16c0-1.14.35-2.13,1.04-2.95.92-1.09,2.32-1.66,3.75-1.66h27.76c1.26,0,2.34.44,3.25,1.32.9.88,1.36,1.98,1.36,3.28v21.71c0,1.31-.45,2.4-1.36,3.28-.91.88-1.99,1.33-3.25,1.33h-27.76c-1.43,0-2.83-.57-3.75-1.66-.7-.82-1.04-1.8-1.04-2.95v-21.71Zm32.75,22.09v-22.48c0-.06-.05-.12-.12-.12h-27.11c-.61,0-1.11.5-1.11,1.11v20.5c0,.61.5,1.11,1.11,1.11h27.11c.06,0,.12-.05.12-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m107.5,78.67c0-.4.14-.74.42-1.01.28-.27.61-.41,1-.41h8.62c.39,0,.72.14,1,.41.28.27.42.61.42,1.01v6.69c0,.4-.14.74-.42,1.01-.28.27-.61.41-1,.41h-8.62c-.39,0-.72-.14-1-.41-.28-.27-.42-.61-.42-1.01v-6.69Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 96.64,
    cy: 82.02,
    r: 5.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m159.03,92.87c0,1.15-.35,2.13-1.04,2.95-.92,1.09-2.32,1.66-3.75,1.66h-27.76c-1.26,0-2.35-.44-3.25-1.32-.9-.88-1.36-1.98-1.36-3.28v-21.71c0-1.3.45-2.4,1.36-3.28.9-.88,1.99-1.32,3.25-1.32h27.76c1.43,0,2.83.57,3.75,1.66.7.82,1.04,1.8,1.04,2.95v21.71Zm-32.63.5h27.11c.61,0,1.11-.5,1.11-1.11v-20.5c0-.61-.5-1.11-1.11-1.11h-27.11c-.06,0-.12.05-.12.12v22.48c0,.06.05.12.12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m135.75,85.36c0,.4-.14.74-.42,1.01-.28.27-.61.41-1,.41h-8.62c-.39,0-.72-.14-1-.41-.28-.27-.42-.61-.42-1.01v-6.69c0-.4.14-.74.42-1.01.28-.27.61-.41,1-.41h8.62c.39,0,.72.14,1,.41.28.27.42.61.42,1.01v6.69Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 146.61,
    cy: 82.02,
    r: 5.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m159.51,71.16c0-1.14.35-2.13,1.04-2.95.92-1.09,2.32-1.66,3.75-1.66h27.76c1.26,0,2.34.44,3.25,1.32.9.88,1.36,1.98,1.36,3.28v21.71c0,1.31-.45,2.4-1.36,3.28-.91.88-1.99,1.33-3.25,1.33h-27.76c-1.43,0-2.83-.57-3.75-1.66-.7-.82-1.04-1.8-1.04-2.95v-21.71Zm32.75,22.09v-22.48c0-.06-.05-.12-.12-.12h-27.11c-.61,0-1.11.5-1.11,1.11v20.5c0,.61.5,1.11,1.11,1.11h27.11c.06,0,.12-.05.12-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m182.79,78.67c0-.4.14-.74.42-1.01.28-.27.61-.41,1-.41h8.62c.39,0,.72.14,1,.41.28.27.42.61.42,1.01v6.69c0,.4-.14.74-.42,1.01-.28.27-.61.41-1,.41h-8.62c-.39,0-.72-.14-1-.41-.28-.27-.42-.61-.42-1.01v-6.69Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 171.93,
    cy: 82.02,
    r: 5.43
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCard1Back);
export default __webpack_public_path__ + "static/media/bank-card-1-back.d8d41dc1fed3ad9cc3fef753096ff5d6.svg";
export { ForwardRef as ReactComponent };